import axiosInstance from "./axiosInstance.ts";

interface PredictorPayload {
  predictor_name: string;
  domain: string;
  problem_type: string;
  dataset_name: string;
}

export const predictorService = {
  getPredictorData: (skip = 0, limit = 10, page = 1) =>
    axiosInstance.get("api/v1/train/", {
      params: { skip, limit, page },
      headers: { Accept: "application/json" },
    }),

  fetchContributingFields: (train_id: number) =>
    axiosInstance.get(`/api/v1/train/${train_id}/feature-importance`),

  generateContributingFields: (train_id: number) =>
    axiosInstance.get(`/api/v1/train/${train_id}/generate-feature-importance`),

  refreshPredictorData: (skip = 0, limit = 10, page = 1) =>
    axiosInstance.get("api/v1/train/refresh", {
      params: { skip, limit, page },
      headers: { Accept: "application/json" },
    }),

  deletePredictorData: (predictorId: number) =>
    axiosInstance.delete(`${`api/v1/train`}/${predictorId}`),

  updatePredictorData: (train_id: number, preprocess_id: number) =>
    axiosInstance.put(`/api/v1/train/`, {
      train_id,
      preprocess_id,
    }),
  getPredictorHeader: (id: string) =>
    axiosInstance.get(`api/v1/inference/${id}/prediction-form`, {
      headers: { Accept: "application/json" },
    }),

  submitPrediction: (
    preprocess_id: number,
    features: Record<string, string>,
    target: string,
    train_id: number
  ) =>
    axiosInstance.post(
      `api/v1/inference/`,
      { preprocess_id, features, target, train_id },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    ),
  TrainPrediction: (
    dataset_id: number,
    predictor_name: string,
    domain: string,
    problem_type: string,
    columns: any,
    is_incremental: boolean = false,
    shap_enabled: boolean = false,
    tune_enabled: boolean = false,
    zero_fill_enabled: boolean = false,
    frequency?: string,
  ) =>
    axiosInstance.post(
      `/api/v1/train/`,
      {
        dataset_id,
        predictor_name,
        domain,
        problem_type,
        columns,
        is_incremental,
        shap_enabled,
        tune_enabled,
        zero_fill_enabled,
        frequency
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    ),

  createPredictor: (payload: PredictorPayload) =>
    axiosInstance.post("/api/v1/train/details", payload),

  ForecastInference: (
    train_id: number,
    preprocess_id: number,
    steps: number,
    frequency: string,
    unique_id: string,
    dataset_id: number,
    used_exogenous: boolean
  ) =>
    axiosInstance.post(
      `/api/v1/inference/forecast`,
      {
        train_id,
        preprocess_id,
        steps,
        frequency,
        unique_id,
        ...(used_exogenous && { dataset_id }),
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    ),
  BatchPrediction: (payload) => axiosInstance.post(`/api/v1/inference/${payload.train_id}/prediction-batch`, payload), headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  GetBatchPredictions: (train_id) => axiosInstance.get(`/api/v1/inference/predictions?train_id=${train_id}`),
  BatchPredictionResult: (prediction_id) => axiosInstance.get(`/api/v1/inference/result?prediction_id=${prediction_id}`),
  ModalSummaryResult: (train_id) => axiosInstance.get(`/api/v1/train/model-summary?train_id=${train_id}`),

  DownloadTemplate: (train_id) => axiosInstance.get(`/api/v1/train/${train_id}/schema`)

};
